module.exports = __webpack_public_path__ + "img/shooting09.107973ff.jpeg";